<template>
  <div class="card mb-5 mb-xxl-8">
    <!--begin::Body-->
    <div class="card mb-5 mb-xl-10" id="kt_profile_details_view">
      <!--begin::Card header-->
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">{{ $t('shop.sales') }}</h3>
        </div>
        <div class="card-toolbar">
          <Select2
              v-model="channelSelected"
              :isRequired="false"
              :multiple="false"
              :show-search="false"
              :placeholderText="$t('shop.sale_channel')"
              :selectClass="'form-select form-select-solid kt_select2 w-200px'"
              containerClass="d-flex flex-column fv-row me-5 mw-500px"
              name="sale-channel"
          >
            <option value="pos">{{ $t('shop.sale_channel_pos') }}</option>
            <option v-if="$hasShopModule('ecommerce')" value="ecommerce">{{ $t('shop.sale_channel_ecommerce') }}</option>
            <option v-if="$hasShopModule('ecommerce')" value="all">{{ $t('shop.sale_channel_all') }}</option>
          </Select2>
          <Select2
              v-model="statusSelected"
              :isRequired="false"
              :multiple="false"
              :show-search="false"
              :placeholderText="$t('e-commerce.checkout.status')"
              :selectClass="'form-select form-select-solid kt_select2 w-200px'"
              containerClass="d-flex flex-column fv-row me-5 mw-500px"
              name="checkout-status"
          >

            <option v-for="(status, index) in getPosCheckoutStatus" :key="index" :value="status.value">
              {{ $i18n.locale == 'fr' ? status.fr : status.en }}
            </option>
          </Select2>
          <div dashboard-kt-daterangepicker="true" data-kt-daterangepicker-opens="left"
               class="btn btn-sm btn-light d-flex align-items-center px-4">
            <div class="text-gray-600 fw-bolder">{{ $t('dashboard.loading') }}...</div>
            <span class="svg-icon svg-icon-1 ms-2 me-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path opacity="0.3"
                            d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z"
                            fill="currentColor" />
                      <path
                          d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z"
                          fill="currentColor" />
                      <path
                          d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z"
                          fill="currentColor" />
                    </svg>
                  </span>
          </div>
        </div>

      </div>
      <!--end::Card header-->

      <div class="d-flex flex-wrap gap-3 mb-5 px-6 sales-stats-row">
        <div class="sales-stat-card">
          <div class="sales-stat-icon sales-stat-icon--sales"><i class="bi bi-receipt"></i></div>
          <div>
            <div class="sales-stat-value">{{ statsLoading ? '…' : stats.sales_count }}</div>
            <div class="sales-stat-label">{{ $t('shop.sales_count') }}</div>
          </div>
        </div>
        <div class="sales-stat-card">
          <div class="sales-stat-icon sales-stat-icon--turnover"><i class="bi bi-cash-stack"></i></div>
          <div>
            <div class="sales-stat-value">{{ statsLoading ? '…' : $formatLocalAmount(stats.total_amount) }} {{ currency }}</div>
            <div class="sales-stat-label">{{ $t('credit.collected_turnover') }}</div>
          </div>
        </div>
        <!-- ventes à crédit : pas encore dans le chiffre d'affaires -->
        <div v-if="stats.credit_due > 0" class="sales-stat-card">
          <div class="sales-stat-icon sales-stat-icon--credit"><i class="bi bi-hourglass-split"></i></div>
          <div>
            <div class="sales-stat-value text-danger">{{ statsLoading ? '…' : $formatLocalAmount(stats.credit_due) }} {{ currency }}</div>
            <div class="sales-stat-label">{{ $t('credit.credit_due_stat') }}</div>
          </div>
        </div>
        <div class="sales-stat-card">
          <div class="sales-stat-icon sales-stat-icon--avg"><i class="bi bi-graph-up"></i></div>
          <div>
            <div class="sales-stat-value">{{ statsLoading ? '…' : $formatLocalAmount(stats.average_amount) }} {{ currency }}</div>
            <div class="sales-stat-label">{{ $t('shop.average_basket') }}</div>
          </div>
        </div>
      </div>

      <div class="card-body">
        <!--begin::Layout-->
        <div class="row">
          <!--begin::Table-->
          <table class="table align-middle table-row-bordered fs-6 gy-3 "  id="kt_datatable_shop_order">
            <thead>
            <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
              <th>{{ $t('contacts.order_number') }}</th>
              <th>{{$t('customer')}}</th>
              <th>{{ $t('shop.total') }}</th>
              <th>Date</th>
              <th> {{$t("e-commerce.status")}}</th>
              <th>{{$t("actions")}}</th>
            </tr>
            </thead>

          </table>
          <!--end::Table-->
        </div>
        <!--end::Layout-->
      </div>
      <!--end::Card body-->
    </div>
    <div class="modal fade" tabindex="-1" id="orderDetailModal">
      <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{$t("shop.invoice")}}</h5>
              <!--begin::Close-->
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                <span class="svg-icon svg-icon-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
              <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
            </svg>
          </span>
                <!--end::Svg Icon-->
              </div>
              <!--end::Close-->
            </div>
            <div class="modal-body">
              <div class="card-body py-5">
                <!-- begin::Wrapper-->
                <div class="mw-lg-950px mx-auto w-100">
                  <!-- begin::Header-->
                  <div class="d-flex justify-content-between flex-column flex-sm-row mb-9">
                    <h4 class="fw-boldest text-gray-800 fs-2qx pe-5 pb-7">{{$t("shop.invoice")}}</h4>
                    <!--end::Logo-->
                    <div class="text-sm-end">
                      <!--begin::Logo-->
                      <!--end::Logo-->
                      <!--begin::Text-->
                      <div class="text-sm-end fw-bold fs-4 text-muted ">
                        <div class="fw-boldest text-gray-800"> {{ formDetailsData.shop_name }}</div>
                        <div>{{ formDetailsData.shop_phone }}</div>
                        <div>{{ formDetailsData.shop_address }} , {{ formDetailsData.shop_country }} </div>
                      </div>
                      <!--end::Text-->
                    </div>
                  </div>
                  <!--end::Header-->
                  <!--begin::Body-->
                  <div class="pb-12">
                    <!--begin::Wrapper-->
                    <div class="d-flex flex-column gap-7 gap-md-10">
                      <!--begin::Message-->

                      <!--begin::Message-->
                      <!--begin::Separator-->
                      <div class="separator"></div>
                      <!--begin::Separator-->
                      <!--begin::Order details-->
                      <div class="d-flex flex-column flex-sm-row gap-7 gap-md-10 fw-bolder">
                        <div class="flex-root d-flex flex-column">
                          <span class="text-muted">{{ $t('contacts.order_number') }}</span>
                          <span class="fs-5">{{ formDetailsData.reference }}</span>
                        </div>
                        <div class="flex-root d-flex flex-column">
                          <span class="text-muted">Date</span>
                          <span class="fs-5">{{ formDetailsData.date }}</span>
                        </div>
                        <div class="flex-root d-flex flex-column" v-show="formDetailsData.customer">
                          <span class="text-muted">{{$t('customer')}}</span>
                          <span class="fs-5">{{ formDetailsData.customer }}</span>
                        </div>
                      </div>

                      <div class="d-flex justify-content-between flex-column">
                        <!--begin::Table-->
                        <div class="table-responsive border-bottom mb-9">
                          <table class="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                            <thead>
                            <tr class="border-bottom fs-6 fw-bolder text-muted">
                              <th class="min-w-175px pb-2">{{ $t('shop.products') }}</th>
                              <th class="min-w-70px text-end pb-2">{{ $t('shop.unit_price') }}</th>
                              <th class="min-w-80px text-end pb-2">{{ $t('shop.quantity') }}</th>
                              <th class="min-w-100px text-end pb-2">{{ $t('shop.total') }}</th>
                            </tr>
                            </thead>
                            <tbody class="fw-bold text-gray-600">
                            <!--begin::Products-->
                            <tr v-for="product in formDetailsData.products" :key="product.id">
                              <!--begin::Product-->
                              <td>
                                <div class="d-flex align-items-center">
                                  <!--begin::Thumbnail-->
<!--                                  <a href="../../demo1/dist/apps/ecommerce/catalog/edit-product.html" class="symbol symbol-50px">-->
<!--                                    <span class="symbol-label" style="background-image:url(assets/media//stock/ecommerce/1.gif);"></span>-->
<!--                                  </a>-->
                                  <!--end::Thumbnail-->
                                  <!--begin::Title-->
                                  <div class="ms-5">
                                    <div class="fw-bolder"> {{product.name }} <br/>
                                      <span v-if="product.discount != 0"  style=" font-size:10px; margin-left: 5px!important">  ({{ $t('remise') }} {{ product.discount }} %)</span>
                                    </div>
                                  </div>
                                  <!--end::Title-->
                                </div>
                              </td>
                              <!--end::Product-->
                              <!--begin::SKU-->
                              <td class="text-end"> {{$formatLocalAmount(product.price )}} {{currency}}</td>
                              <!--end::SKU-->
                              <!--begin::Quantity-->
                              <td class="text-end">{{product.quantity }}</td>
                              <!--end::Quantity-->
                              <!--begin::Total-->
                              <td class="text-end">  {{$formatLocalAmount(product.quantity_price) }} {{currency}}</td>
                              <!--end::Total-->
                            </tr>

                            <!--end::Products-->
                            <!--begin::Subtotal-->
                            <tr>
                              <td colspan="3" class="text-end">{{ $t('shop.subtotal') }}</td>
                              <td class="text-end">{{$formatLocalAmount(formDetailsData.sub_total) }} {{currency}}</td>
                            </tr>
                            <!--end::Subtotal-->
                            <!--begin::VAT-->
                            <tr>
                              <td colspan="3" class="text-end">{{ $t('shop.reduction') }} </td>
                              <td class="text-end"> {{$formatLocalAmount(formDetailsData.reduction)}} {{currency}}</td>
                            </tr>
                            <tr>
                              <td colspan="3" class="text-end">{{ $t('shop.cash') }} </td>
                              <td class="text-end"> {{$formatLocalAmount(formDetailsData.amountDonated)}} {{currency}}</td>
                            </tr>
                            <tr>
                              <td colspan="3" class="text-end">{{ $t('shop.remise_cash') }} </td>
                              <td class="text-end"> {{$formatLocalAmount(formDetailsData.cash_change)}} {{currency}}</td>
                            </tr>
                            <tr>
                              <td colspan="3" class="fs-3 text-dark fw-bolder text-end">{{ $t('shop.total') }}</td>
                              <td class="text-dark fs-3 fw-boldest text-end"> {{$formatLocalAmount(formDetailsData.total )}} {{currency}}</td>
                            </tr>
                            <!--end::Grand total-->
                            </tbody>
                          </table>
                        </div>
                        <!--end::Table-->
                      </div>
                      <!--end:Order summary-->
                    </div>
                    <!--end::Wrapper-->
                  </div>
                  <!--end::Body-->
                  <div class="modal-footer">
                    <button v-show="false" type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
                  </div>
                </div>
                <!-- end::Wrapper-->
              </div>
            </div>

          </div>
      </div>
    </div>

    <TicketModal
      :sale="formDetailsData"
      :currency="currency"
      :is-load="isLoading"
      :is-loading="isLoading"
      :symef-response="symefResponse"
      @print="printButton"
      @normalize="generateSymefInvoice"
    />

    <InvoicePdfModal ref="ecommerceInvoiceModal" modal-id="ecommerceInvoiceModal" />

    <!--end::Body-->
  </div>
</template>

<script>
import {BASE_URL} from "@/services/api";
import OrderDetails from "@/components/shop/OrderDetails";
import Select2 from "@/components/Select2";
import TicketModal from "@/components/TicketModal";
import InvoicePdfModal from "@/components/InvoicePdfModal";
import {mapActions, mapGetters} from "vuex";
import router from "@/router";

export default {
  name: "Order",
  components: {OrderDetails, Select2, TicketModal, InvoicePdfModal},
  data(){
    return{
      formDetailsData: {
        id: null,
        row: null,
        reference : '',
        customer :'',
        sub_total : 0,
        reduction : 0,
        shop_address : '',
        shop_phone : '',
        shop_name  : '',
        shop_country  : '',
        shop_ifu_number: '',
        shop_rccm_number: '',
        date  : '',
        operator : '',
        products: [],
        cash_change: 0,
        amountDonated: 0,
        acompte_amount: 0,
        acompte_remaining: 0,
        status: ''
      },
      currency : '',
      startDate: null,
      endDate: null,
      statusSelected: 'all',
      channelSelected: 'pos',
      isLoading: false,
      checkout_id: null,
      isNormalized: false,
      symefResponse: null,
      stats: {
        sales_count: 0,
        total_amount: 0,
        average_amount: 0,
        credit_due: 0,
      },
      statsLoading: false,
    }
  },
  watch:{
    '$i18n.locale' : function(value){
      if(value && this.table){
        this.$nextTick(() =>   this.fetchDatas())
      }
    },
    'statusSelected' : function(value){
      if(value && this.table && !this._suppressAutoFetch){
        let url =  BASE_URL +'/get/shop/' + this.$route.params.id + '/orders/datatables' + `?startDate=${this.startDate}&endDate=${this.endDate}&status=${this.statusSelected}&channel=${this.channelSelected}`
        this.table.ajax.url(url).load()
        this.fetchStats()
      }
    },
    'channelSelected' : function(value){
      if(value && this.table && !this._suppressAutoFetch){
        let url =  BASE_URL +'/get/shop/' + this.$route.params.id + '/orders/datatables' + `?startDate=${this.startDate}&endDate=${this.endDate}&status=${this.statusSelected}&channel=${this.channelSelected}`
        this.table.ajax.url(url).load()
        this.fetchStats()
      }
    },
    'startDate' : function(value){
      if(this.startDate && !this._suppressAutoFetch){
        this.$nextTick(() =>    this.fetchDatas())
        this.fetchStats()
      }
    },
    '$route.params.id': function(newId, oldId){
      // Vue Router réutilise ce composant quand on passe de la fiche d'une
      // boutique à une autre (même route, seul :id change) — sans ce watcher,
      // la datatable garde l'URL/les données de l'ancienne boutique (bug de
      // fuite entre boutiques constaté par Rachid : ventes de la boutique 2
      // visibles dans la liste de la boutique 1).
      if (newId && newId !== oldId) {
        this.initForShop()
      }
    },
  },
  computed: {
    ...mapGetters('shop', [
      'getPosCheckoutStatus'
    ]),
    locale() {
      return this.$i18n?.locale;
    },
  },
  beforeUnmount() {
    this._unmounted = true
    if (this.table) {
      // annule la requête en cours : sa réponse ne doit pas être rendue après le démontage
      try { this.table.settings()[0].jqXHR?.abort() } catch (e) {}
      try { this.table.destroy(false) } catch (e) {}
      this.table = null
    }
    $(document).off("click", "#kt_datatable_shop_order .order_view_btn")
  },

  async mounted(){
    this._unmounted = false
    await this.initForShop()

    $(document).on("click", "#kt_datatable_shop_order .ecommerce_invoice_btn", (e) => {
      const checkoutId = e.currentTarget.getAttribute('data-id')
      this.openEcommerceInvoice(checkoutId)
    });

    $(document).on("click", "#kt_datatable_shop_order .order_view_btn", async(e) => {
      let orderStatus = e.target.getAttribute('data-status')
      let orderId = e.target.getAttribute('data-id')
      let isAdvanced = e.target.getAttribute('data-advanced')
      this.checkout_id = orderId
      await this.verifySymefInvoice()
        if(isAdvanced === 'yes') {
          this.$router.push({name: 'order-details', params: {detail_id: orderId}})
        }else{
          Promise.all([
            this.formDetailsData.status = orderStatus,
            this.formDetailsData.id = orderId,
            this.formDetailsData.row = e.target.getAttribute('data-row'),
            this.formDetailsData.reference = e.target.getAttribute('data-ref'),
            this.formDetailsData.customer = e.target.getAttribute('data-customer'),
            this.formDetailsData.sub_total = e.target.getAttribute('data-sub-total'),
            this.formDetailsData.total = e.target.getAttribute('data-total'),
            this.formDetailsData.reduction = e.target.getAttribute('data-reduction'),
            this.formDetailsData.shop_address = e.target.getAttribute('data-shop-address'),
            this.formDetailsData.shop_phone = e.target.getAttribute('data-shop-phone'),
            this.formDetailsData.shop_country = e.target.getAttribute('data-shop-country'),
            this.formDetailsData.shop_ifu_number = e.target.getAttribute('data-shop-ifu'),
            this.formDetailsData.shop_rccm_number = e.target.getAttribute('data-shop-rccm'),
            this.formDetailsData.shop_name = e.target.getAttribute('data-shop-name'),
            this.formDetailsData.date = e.target.getAttribute('data-date'),
            this.formDetailsData.cash_change = e.target.getAttribute('data-cash-change'),
            this.formDetailsData.amountDonated = e.target.getAttribute('data-amountDonated'),
            this.formDetailsData.products = JSON.parse(decodeURIComponent(e.target.getAttribute('data-products'))),
            this.formDetailsData.operator = e.target.getAttribute('data-operator'),
            this.formDetailsData.acompte_amount = e.target.getAttribute('data-acompte-amount'),
            this.formDetailsData.acompte_remaining = e.target.getAttribute('data-acompte-remaining'),
            this.formDetailsData.status = e.target.getAttribute('data-status')
          ]).then(() => {
            $('#kt_modal_1').modal('toggle')
          })
      }
    });
  },

  methods: {
    async initForShop() {
      // Empêche les watchers (statusSelected/channelSelected/startDate) de
      // déclencher chacun leur propre rechargement pendant cette
      // initialisation : un seul fetchDatas() explicite à la fin, sinon
      // plusieurs appels quasi simultanés à .DataTable() se marchent dessus
      // ("Cannot reinitialise DataTable").
      this._suppressAutoFetch = true
      await this.loadShopModules(this.$route.params.id)
      // "Tous" par défaut quand le module e-commerce est actif (sinon cette
      // option n'existe même pas dans le filtre, on reste sur "pos").
      this.channelSelected = this.$hasShopModule('ecommerce') ? 'all' : 'pos'
      $('body .pre').css('display', 'block')
      await this.initDateRange()
      $('body .pre').css('display', 'none')
      this.loadPosCheckoutStatus()
      this.getShopCurrency()
      this._suppressAutoFetch = false
      this.$nextTick(() => this.fetchDatas())
      this.fetchStats()
    },
    ...mapActions('shop', ['loadPosCheckoutStatus']),
    ...mapActions('session', ['normalizationInvoice', 'verifyInvoiceNormalization']),
    ...mapActions('tenantModule', ['loadShopModules']),
    async fetchStats() {
      if (!this.startDate || !this.endDate) return
      this.statsLoading = true
      try {
        const response = await axios.get(
          `get/shop/${this.$route.params.id}/orders/stats`,
          { params: { startDate: this.startDate, endDate: this.endDate, status: this.statusSelected, channel: this.channelSelected } }
        )
        this.stats = response.data.data
      } catch (e) {
        // silencieux : les cartes gardent leur dernière valeur connue
      } finally {
        this.statsLoading = false
      }
    },
    // Commande e-commerce : on affiche directement la facture (composant
    // partagé InvoicePdfModal), plutôt que de rediriger vers le destockage
    // qui ne concerne que le traitement/suivi de la commande, pas la facture.
    openEcommerceInvoice(checkoutId) {
      this.$refs.ecommerceInvoiceModal.open(checkoutId)
    },
    getShopCurrency() {
      const sessionCurrency = this.$store.getters['session/getCurrency']
      this.currency = sessionCurrency?.iso || sessionCurrency?.symbole || 'XOF'
      this.iso = sessionCurrency?.iso || 'XOF'
    },

    async generateSymefInvoice() {
      this.isLoading = true
      try {
        let response = await this.normalizationInvoice(this.checkout_id)
        this.symefResponse = response.data
        window.toastr['success'](i18n.global.t('shop.success_invoice'))
      } catch (e) {
      }
      this.isLoading = false
    },

    async verifySymefInvoice() {
      this.isLoading = true
      this.isNormalized = false
      let response = await this.verifyInvoiceNormalization(this.checkout_id)
      this.symefResponse = response.data
      if (this.symefResponse) {
        this.isNormalized = true
      }
      this.isLoading = false
    },

   async fetchDatas(){
      if (this._unmounted) return
      const tableEl = document.getElementById('kt_datatable_shop_order')
      if (!tableEl) return
      // Vérifie l'état réel du plugin sur le DOM (pas seulement la variable
      // this.table) : des appels rapprochés (ex. initForShop() lors d'un
      // changement de boutique) peuvent se chevaucher et laisser this.table
      // désynchronisé de l'instance réellement attachée à la table, d'où le
      // warning DataTables "Cannot reinitialise DataTable".
      if ($.fn.dataTable.isDataTable('#kt_datatable_shop_order')) {
        try { $('#kt_datatable_shop_order').DataTable().destroy(false) } catch (e) {}
      }
      this.table = null
      const AUTH_TOKEN = Ls.get('auth.token')

      this.table = $("#kt_datatable_shop_order").DataTable({
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength:Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100 ],
        order: [[ 3, 'desc']],
        ajax: {
          url:  BASE_URL +'/get/shop/' + this.$route.params.id + '/orders/datatables' + `?startDate=${this.startDate}&endDate=${this.endDate}&channel=${this.channelSelected}`,

          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },
          data:  function ( d ) {

          }
        },
        columns: [{ data: "reference" },{ data: "customer" },{ data: "total" },{ data: "date" },{ data: "status" }, { data: "Actions", responsivePriority: -1 }],

        columnDefs: [
          {
            targets: -6,
            order: "desc",
            render: (t, a, e, l) => {
              const channelBadge = e.channel === 'ECOMMERCE'
                  ? '<span class="badge badge-light-info me-2">' + i18n.global.t('shop.sale_channel_ecommerce') + '</span>'
                  : '<span class="badge badge-light-primary me-2">' + i18n.global.t('shop.sale_channel_pos') + '</span>';
              const showBadge = this.channelSelected === 'all';
              return (showBadge ? channelBadge : '') + '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -5,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -4,
            order: "desc",
            className: "dt-center clickable",
            render: (t, a, e, l) => {
              return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + this.$formatLocalAmount(t) + "<span> "+ this.currency +"</span></span>";
            },
          },
          {
            targets: -3,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + moment(t).format('DD-MM-YYYY HH:mm') + "</span>";
            },
          },
          {
            targets: -2,
            orderable:false,
            searchable:false,
            render:  (t, a, e, l) => {
              // Les statuts e-commerce (CheckoutStatusEnum) n'ont pas le même
              // référentiel que les statuts POS (PosCheckoutStatusEnum) :
              // le backend envoie directement le libellé/couleur pour ces lignes.
              if (e.channel === 'ECOMMERCE') {
                const color = e.status_color || 'secondary'
                return '<span data-id="'+ e.id +'" class="badge badge-light-'+ color +'">' + (e.status_label || t) + "</span>";
              }
              // même présentation (badge) que les commandes en ligne
              const type = (this.getStatusClass(t) || 'text-secondary').replace('text-', '')
              let status = this.getStatusLocale(t)
              return '<span data-id="'+ e.id +'" class="badge badge-light-'+ type +'">' + status + "</span>";

            },
          },
          {
            width: "15%",
            targets: -1,
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              let render=""
              if (e.channel === 'ECOMMERCE') {
                // Pas de modale POS pour ces commandes : le premier bouton
                // affiche la facture (comme sur l'espace client). Tant que la
                // commande n'est pas terminée (livrée/annulée), on garde un
                // accès direct au destockage pour poursuivre son traitement.
                if (this.$can('sale_detail_boutique_view')) {
                  render += '<div class="d-flex align-items-center flex-nowrap" style="gap:6px;">'
                  render += '<button type="button" data-id="' + e.id + '" class="btn btn-icon btn-active-light-primary w-30px h-30px ecommerce_invoice_btn" title="' + this.$t('shop.invoice') + '"><i class="fa fa-eye"></i></button>'
                  if (!['DELIVERED', 'CANCELED'].includes(e.status)) {
                    render += '<a href="/admin/ecommerce/orders/' + e.id + '/view/destockage" class="btn btn-icon btn-active-light-primary w-30px h-30px" title="' + this.$t('destockage.list') + '"><i class="fa fa-tasks"></i></a>'
                  }
                  render += '</div>'
                }
                return render
              }
              if(this.$can('sale_detail_boutique_view')  ){
                const encodedProducts = encodeURIComponent(JSON.stringify(e.products))
                render+='<div class="d-flex align-items-center flex-nowrap" style="gap:6px;">'
                render+='<button type="button" data-id="'+ e.id +'" data-operator="' + e.operator + '" data-advanced="'+ e.is_advanced +'" data-status="'+ e.status +'"  data-row="'+ l.row +'" data-ref="'+ e.reference +'"   data-shop-name="'+ e.shop_name +'"   data-shop-phone="'+ e.shop_phone +'"   data-shop-address="'+ e.shop_address +'" data-shop-country="'+ e.shop_country +'" data-shop-ifu="'+ (e.shop_ifu_number || '') +'" data-shop-rccm="'+ (e.shop_rccm_number || '') +'"  data-reduction="'+ e.reduction +'" data-sub-total="'+ e.sub_total +'" data-total="'+ e.total +'" data-customer="'+ e.customer +'" data-date="'+ e.date +'" data-cash-change="' + e.cash_change + '" data-amountDonated="' + e.amountDonated + '" data-products="'+ encodedProducts +'" data-acompte-amount="' + e.acompte_amount + '"  data-acompte-remaining="' + e.acompte_remaining + '" class="btn btn-icon btn-active-light-primary w-30px h-30px order_view_btn" >' +
                    '<i  data-id="'+ e.id +'" data-operator="' + e.operator + '" data-advanced="'+ e.is_advanced +'"  data-status="'+ e.status +'"   data-row="'+ l.row +'"   data-ref="'+ e.reference +'"   data-shop-name="'+ e.shop_name +'"   data-shop-phone="'+ e.shop_phone +'"   data-shop-address="'+ e.shop_address +'"  data-shop-country="'+ e.shop_country +'"  data-reduction="'+ e.reduction +'" data-sub-total="'+ e.sub_total +'" data-total="'+ e.total +'" data-customer="'+ e.customer +'"  data-date="'+ e.date +'"  data-cash-change="' + e.cash_change + '" data-amountDonated="' + e.amountDonated + '" data-products="'+ encodedProducts +'"  data-acompte-amount="' + e.acompte_amount + '"  data-acompte-remaining="' + e.acompte_remaining + '" class="fa fa-eye"></i>' +
                    '</button>'
                render+='</div>'
              }


              return render
            },
          },

        ],
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json" ,
        }
      });
    },

    async initDateRange() {
      this.isReady = false
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]');
      let start = moment().subtract(7, 'days');
      let end = moment();

      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')

      $(element).daterangepicker({
        direction: KTUtil.isRTL(),
        startDate: start,
        endDate: end,
        opens: 'left',
        applyClass: 'btn-primary',
        cancelClass: 'btn-light-primary',
        locale: {
          format: 'DD/MM/YYYY',
          separator: ' - ',
          applyLabel: i18n.global.t('apply'),
          cancelLabel: i18n.global.t('cancel'),
          fromLabel: i18n.global.t('from'),
          toLabel: i18n.global.t('to'),
          customRangeLabel: i18n.global.t('custom_range'),
          weekLabel: 'S',
          daysOfWeek: [i18n.global.t('di'),i18n.global.t('lu'),i18n.global.t('ma'),i18n.global.t('me'),i18n.global.t('je'),i18n.global.t('ve'),i18n.global.t('sa')],
          monthNames: [i18n.global.t('january'), i18n.global.t('february'), i18n.global.t('march'), i18n.global.t('april'), i18n.global.t('may'),
            i18n.global.t('june'), i18n.global.t('july'),  i18n.global.t('august'),  i18n.global.t('september'),  i18n.global.t('october'),  i18n.global.t('november'),  i18n.global.t('december')],
          firstDay: 1
        },
        ranges: {
          [i18n.global.t('today')]: [moment(), moment()],
          [i18n.global.t('yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          [i18n.global.t('last7Days')]: [moment().subtract(6, 'days'), moment()],
          [i18n.global.t('last30Days')]: [moment().subtract(29, 'days'), moment()],
          [i18n.global.t('thisMonth')]: [moment().startOf('month'), moment().endOf('month')],
          [i18n.global.t('lastMonth')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]

        }
      }, this.cb);
      this.cb(start, end);

    },

    async cb(start, end) {
      this.isReady = false
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]');
      let display = element.querySelector('div');
      if (display) {
        display.innerHTML = start.format('D MMM YYYY') + ' - ' + end.format('D MMM YYYY');
      }
      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')
    },

    getStatusClass(statut){
      let posCheckoutStatus =   this.getPosCheckoutStatus.find(stat => stat.value === statut)
      if(posCheckoutStatus){
        return posCheckoutStatus.className
      }
      return ''

    },

    getStatusLocale(statut){
      let checkoutStatus = this.getPosCheckoutStatus.find(stat => stat.value === statut)
      if(checkoutStatus){
        if(this.locale === 'fr'){
          return  checkoutStatus.fr
        }else{
          return  checkoutStatus.en
        }
      }
      return ''

    },

    async downloadInvoice(shop=this.$route.params.id , id){
      await axios.get('shop/'+ shop + '/order/'+ id +'/details/pdf', { responseType: 'blob' })
          .then((res) => {
            if(res.data.type === 'application/json'){
              window.toastr['info']("Contract not found")
            }else {
              let blob = new Blob([res.data], { type: res.headers['content-type'] });
              let link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = "contract.pdf"
              link.click()
            }
          })
          .catch((error) => {
            console.log(error)
          })
    },

    printButton() {
      let prtHtml = document.getElementById('invoice');
      let WinPrint = window.open('', 'Print-Window', 'left=0,top=0,width=400,height=600,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(`<!DOCTYPE html>
        <html><head><title>Ticket</title><style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body { font-family: 'Courier New', Courier, monospace; font-size: 12px; width: 80mm; padding: 5mm; }
          table { width: 100%; border-collapse: collapse; }
          td { padding: 2px 0; vertical-align: top; font-size: 12px; }
          .text-center { text-align: center; } .text-right { text-align: right; }
          .company-name { font-size: 16px; font-weight: bold; }
          .separator { text-align: center; padding: 5px 0 !important; }
          .separator-light { border-bottom: 1px solid #eee; padding: 3px 0 !important; }
          .product-name-cell { width: 55%; } .product-price-cell { width: 45%; text-align: right; }
          .discount-text { font-size: 10px; font-style: italic; }
            .ifu-rccm-line { font-size: 9px !important; }
            .nowrap-unit { white-space: nowrap; }
          .total-final-row td { font-size: 14px; font-weight: bold; padding-top: 5px !important; }
          .remaining-row td { font-weight: bold; }
          .qr-section { margin-top: 10px; padding: 8px; border: 1px solid #000; }
          .qr-table td { font-size: 10px; padding: 1px 0; }
          .qr-code { text-align: center; margin-top: 8px; }
          .receipt-footer { text-align: center; margin-top: 10px; }
          .thanks-text { font-weight: bold; text-transform: uppercase; letter-spacing: 1px; }
          @media print { body { width: 80mm; margin: 0; padding: 2mm; } @page { margin: 0; size: 80mm auto; } }
        </style></head><body>${prtHtml.innerHTML}</body></html>`);
      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(() => { WinPrint.print(); }, 250);
    },
  }
}
</script>

<style scoped>
.sales-stats-row {
  align-items: stretch;
}
.sales-stat-card {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1 200px;
  min-width: 200px;
  padding: 14px 18px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #eef0f4;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);
}
.sales-stat-icon {
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
.sales-stat-icon--sales {
  background: rgba(54, 153, 255, 0.12);
  color: #3699ff;
}
.sales-stat-icon--turnover {
  background: rgba(28, 200, 138, 0.12);
  color: #1cc88a;
}
.sales-stat-icon--avg {
  background: rgba(246, 194, 62, 0.15);
  color: #d4a017;
}
.sales-stat-icon--credit {
  background: rgba(241, 65, 108, 0.12);
  color: #f1416c;
}
.sales-stat-value {
  font-size: 17px;
  font-weight: 700;
  color: #181c32;
  line-height: 1.2;
}
.sales-stat-label {
  font-size: 12px;
  color: #a1a5b7;
  margin-top: 2px;
}
</style>

